import * as React from "react";
import {
  Box,
  Typography,
  Stack,
  Paper,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useI18n } from "../../i18n/I18nProvider";
import { useWorkshopBlocker, FLOW } from "../../logic/useWorkshopBlocker";


export default function CommunityPreparedness(props: {handlePageChange: (p: string) => void}) {
  const { handlePageChange } = props;
  const blocker = useWorkshopBlocker();
  const { lang } = useI18n();
  const isDE = lang === "de";
  const [notice, setNotice] = React.useState<string | null>(null);

  const myIndex = FLOW.indexOf("CommunityPreparedness");
  const blockerIndex = FLOW.indexOf(blocker);
  const canContinue = blockerIndex > myIndex;
  
  function handleContinue() {
    if (canContinue) {
      handlePageChange(FLOW[myIndex + 1]);
      return;
    }
    setNotice("ENG / DE");
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        px: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: `
          radial-gradient(circle at 20% 20%, rgba(251, 2, 2, 0.08), transparent 40%),
          radial-gradient(circle at 80% 30%, rgba(255, 0, 0, 0.06), transparent 40%),
          #111010
        `,
        backgroundImage: `
          linear-gradient(
            rgba(8, 8, 8, 0.78),
            rgba(8, 8, 8, 0.82)
          ),
          url("/scenarioBgs/communityPrep.png")
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: { xs: "scroll", md: "fixed" },
        py: { xs: 3, sm: 5 },
      }}
    >
      <Paper
        sx={{
          width: "min(900px, 100%)",
          maxWidth: 900,
          p: { xs: 2.5, sm: 4, md: 5 },
          borderRadius: { xs: 3, sm: 5 },
          background: "linear-gradient(180deg, #311f1f, #221515)",
        }}
      >
        <Stack spacing={{ xs: 3, sm: 4 }}>

          {/* TITLE */}
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 800,
              fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.6rem" },
            }}
          >
            {isDE ? "👉 KOMMUNIKATION" : "👉 COMMUNICATION"}
          </Typography>

          {/* MAIN QUESTIONS */}
          <Typography
            sx={{
              color: "#ccc",
              whiteSpace: "pre-line",
              lineHeight: 1.7,
            }}
          >
            {isDE
              ? `Siehst du das Gebäude gegenüber?
                Du bist nun vorbereitet. Aber was nützt deine Vorbereitung, wenn es jetzt zu einem Stromausfall kommt und all die Menschen in diesem Gebäude nicht vorbereitet sind?
                Wenn deine Nachbarn nicht vorbereitet sind.`
              : `Do you see the building opposite?
                You are prepared now. But what is your preparedness worth if there is a power outage now and all the people in that building are not prepared?
                If your neighbors are not prepared.`}
          </Typography>

          {/* EMPHASIS BLOCK */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(255,255,255,0.03)",
            }}
          >
            <Typography
              sx={{
                color: "#ff8a8a",
                fontWeight: 700,
              }}
            >
              {isDE
                ? "Wenn nur einer vorbereitet ist, ist niemand vorbereitet."
                : "If only one is prepared, no one is prepared."}
            </Typography>
          </Box>

            <Button
              variant="contained"
              onClick={handleContinue}
              sx={{
                mt: 1,
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 800,
                px: 3,
                bgcolor: canContinue ? "#ffffff" : "rgba(255,255,255,0.35)",
                color: canContinue ? "#111827" : "rgba(255,255,255,0.8)",
                "&:hover": {
                  bgcolor: canContinue ? "#f3f4f6" : "rgba(255,255,255,0.35)",
                },
              }}
            >
              {isDE ? "Weiter" : "Continue"}
            </Button>
        </Stack>
      </Paper>
      <Snackbar
        open={Boolean(notice)}
        autoHideDuration={5000}
        onClose={() => setNotice(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setNotice(null)} severity="info" sx={{ width: "100%", fontWeight: 700 }}>
          {isDE ? "Die Workshop-Leitung wird diesen Schritt freigeben, oder bitte beantworte die Frage vollständig und sende sie zuerst ab." : "The workshop holder will enable this step, or please complete and submit your answer first."}
        </Alert>
      </Snackbar>
    </Box>
  );
}